import type {
  HeartbeatPluginConfig,
  LoadRequest,
} from "@foundation-player/api";
import { Media } from "./media_player.types";
import { Plugin } from "./media_plugin.js";

/**
 * For further information on the Heartbeat plugin, please also refer
 * to the corresponding API documentation in the Foundation Player documentation:
 *
 * @see https://docs.player.foundation/v2/api/type/load-request/#plugins
 * @see https://docs.player.foundation/v2/api/type/load-request/#foundationpluginheartbeat
 * @see https://docs.player.foundation/v2/api/type/heartbeat-plugin-config/
 */
export class PluginHeartbeat extends Plugin {
  public constructor(media: Media) {
    super(media);
  }

  public isEnabled(): boolean {
    return true;
  }

  public addFoundationLoadRequestPlugins(): LoadRequest["plugins"] {
    const heartbeatPluginConfig: HeartbeatPluginConfig = {
      enabled: true,
      id: "1012674",
      payStatus: this.media.restricted ? 11 : 10,
      userStatus: this.media.userNoad ? 5 : 3,
      kidsProfile: false,
      startType: 0,
      ivw: "/developer/default",
      offer: "rtlpweb",
    };
    return {
      "foundation.plugin.heartbeat": heartbeatPluginConfig,
    };
  }
}
